import React, { useEffect, useState } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import TextfieldNumberSPF from "../../../components/textfields/textfield.number.spf";
import SelectDepartement from "../../../components/selects/select.departement";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import DeboursQuestion from "../../../components/questions/DeboursQuestion";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires";
import {useSnackbar} from "notistack";


// Constitution de société́ avec apport immobilier à titre pur et simple et à titre onéreux
// Id simulateur 82

function Simulateur_82(props) {
  const dispatch = useDispatch();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }

  const [departement, setDepartement] = useState(0);
  const [valeur_biens_apportes, setBiens] = useState(0);
  const [apport_pur_simple, setApportPS] = useState(0);
  const [apport_onereux, setOnereux] = useState(0);
  const [nombre_spf, setNbSPF] = useState(0);
  const [valeursSPF, setValeursSPF] = useState([]);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  const MAX_SPF = 100;  

  const handleChange = async (setter, value, key) => {
    if (setter === setDepartement) {
      setDepartement(parseInt(value));
      setInRedux(setDepartement, parseInt(value), key);
      return;
    }

    if (setter === setNbSPF) {
      const raw = parseInt(value || 0, 10);
      const n = raw > MAX_SPF ? MAX_SPF : raw;

      setNbSPF(n);
      setInRedux(setNbSPF, n, key);

      if (raw > MAX_SPF) {
        enqueueSnackbar(`La quantité maximale de SPF est de ${MAX_SPF}`, {
          variant: "warning",
        });
      }
      return;
    }

    setter(value);
    setInRedux(setter, value, key);
  };

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };
  useEffect(async () => {
    if (nombre_spf > 1) {
      if (valeursSPF.length < nombre_spf) {
        let handle = [];
        for (let i = 0; i < valeursSPF.length; i++) {
          handle[i] = valeursSPF[i];
        }
        for (let i = valeursSPF.length; i < nombre_spf; i++) {
          handle[i] = {};
        }
        await handleChange(setValeursSPF, handle);
      } else if (nombre_spf < valeursSPF.length) {
        //console.log("SPLICE CASE")
        valeursSPF.splice(parseInt(nombre_spf));
        await handleChange(setValeursSPF, valeursSPF);
      }
    } else {
      await handleChange(setValeursSPF, []);
    }
  }, [nombre_spf]);

  function setInRedux(setter, value, key) {
    if (props.isParent) {
      let object = {
        simulateurid: props.simulateur.id,
        departementid: parseInt(departement),
        inputs: {
          valeur_biens_apportes: parseInt(valeur_biens_apportes),
          apport_pur_simple: parseInt(apport_pur_simple),
          apport_onereux: parseInt(apport_onereux),
          nombre_spf: parseInt(nombre_spf),
          montant_deb_add: parseInt(montantDeboursAdditionnels),
          debours_additionnels: parseInt(deboursAdditionnels),
          convention_honoraires : parseInt(props.conventionHonoraires),
        },
        pdfInputs: {
          nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
          object_convention_honoraires : props.objectConventionHonoraires,
          montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
          nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
          adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
        },
        dependances: valeursSPF,
      };

      //For values coming from components
      if (key) {
        if (key === "debours_additionnels") {
          if (value === 0) {
            setMontantDeboursAdditionnels(0)
            Object.assign(object["inputs"], { montant_deb_add: parseInt(0) });
          }
          Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
        }
        if (key === "montant_deb_add") {
          Object.assign(object["inputs"], { montant_deb_add: parseInt(value) });
        }
      }
      //For internal settings
      if (setter === setDepartement) {
        object.departementid = parseInt(value);
      }

      if (setter === setBiens) {
        Object.assign(object["inputs"], { valeur_biens_apportes: parseInt(value) });
      }

      if (setter === setApportPS) {
        Object.assign(object["inputs"], { apport_pur_simple: parseInt(value) });
      }

      if (setter === setOnereux) {
        Object.assign(object["inputs"], { apport_onereux: parseInt(value) });
      }

      if (setter === setNbSPF) {
        Object.assign(object["inputs"], { nombre_spf: parseInt(value) });
      }

      if (setter === setValeursSPF) {
        object.dependances = value;
      }

      if (setter === props.setConventionHonoraires) {
        if(value === 0){
          props.setNombreConventionHonoraires(1);
          props.setObjectConventionHonoraires(null);
          props.setMontantConventionHonoraires(null);
          props.setNomSignataireConventionHonoraires(null);
          props.setAdresseSignataireConventionHonoraires(null);
          Object.assign(
            object["inputs"], { convention_honoraires : parseInt(value) },
            object["pdfInputs"], {
              nombre_convention_honoraires : null,
              object_convention_honoraires : null,
              montant_convention_honoraires : null,
              nom_signataire_convention_honoraires : null,
              adresse_signataire_convention_honoraires : null
            },
          );
        } else {
          Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
        }
      }

      if (setter === props.setNombreConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) });
      }

      if (setter === props.setObjectConventionHonoraires) {
        Object.assign(object["pdfInputs"], { object_convention_honoraires : value });
      }

      if (setter === props.setMontantConventionHonoraires) {
        Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)});
      }

      if (setter === props.setNomSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value });
      }

      if (setter === props.setAdresseSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value });
      }

      //console.log(JSON.stringify(object))
      dispatch(setSimulateurObject(object));
    } else {
      // process child simu
    }
  }

  function functionSetValeursSPF(index, value) {
    //console.log("index : " + index)
    //console.log("value : " + value)
    if (valeursSPF.length >= 2) {
      let formatedData = {
        valeur_spf: parseInt(value),
      };
      valeursSPF[index] = formatedData;
      setInRedux(setValeursSPF, valeursSPF);
    }
  }

  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
        <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} />

        <TextfieldRemarques handleChange={handleChangeRemarque} />

        <p style={styles.cardSubTitle}>
          Acte tarifé au titre du Tableau 5, n° 159 (Art A444-158). En plus de l’honoraire relatif à la constitution de
          la société, des émoluments (acte et formalités) sont à prévoir sur les biens immobiliers apportés.
        </p>

        {props?.isParent === true && props.departements !== "" ? (
          <>
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>Département :</div>

              <SelectDepartement
                items={props.departements}
                nameField={"name"}
                defaultValue={currUserDep}
                optionValue={"id"}
                handleChange={handleChange}
                setter={setDepartement}
              />
            </div>
            <div style={styles.cardRowSpecialMessage}>
              La taxe départementale utilisée pour vos calculs est bien celle qui a été votée dans votre département. Attention de bien penser à indiquer le bon département lorsque vous effectuez une vente sur un département qui n’est pas le votre.
            </div>
          </>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Quelle est la valeur totale des biens immobiliers apportés ?</div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer la valeur"}
            setter={setBiens}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Dont apport à titre pur et simple :</div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer la valeur"}
            setter={setApportPS}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Dont apport à titre onéreux :</div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer la valeur"}
            setter={setOnereux}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Quel est le nombre de SPF concernés par l’apport immobilier ?
          </div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le nombre"}
            setter={setNbSPF}
          />
        </div>

        {valeursSPF.length >= 2 ? (
          valeursSPF.map((valeur, index) => {
            return (
              <div style={styles.cardRowChild}>
                <div className="cardRow">
                  <div style={styles.cardElemVerticalyCenter}>
                    Quelle est la valeur du bien apporté au SPF n° {index + 1} ?
                  </div>
                  <TextfieldNumberSPF
                    index={index}
                    type={"number"}
                    placeholder={"Indiquer la valeur"}
                    functionSetValeurs={functionSetValeursSPF}
                  />
                </div>
              </div>
            );
          })
        ) : (
          <></>
        )}

        <DeboursQuestion
            handleChange={handleChange}
            deboursAdditionnels={deboursAdditionnels}
            setDeboursAdditionnels={setDeboursAdditionnels}
            setMontantDeboursAdditionnels={setMontantDeboursAdditionnels}
        />


        <ConventionHonoraires
          handleChange={handleChange}
          conventionHonoraires={props.conventionHonoraires}
          setConventionHonoraires={props.setConventionHonoraires}
          nombreConventionHonoraires={props.nombreConventionHonoraires}
          setNombreConventionHonoraires={props.setNombreConventionHonoraires}
          objectConventionHonoraires={props.objectConventionHonoraires}
          setObjectConventionHonoraires={props.setObjectConventionHonoraires}
          montantConventionHonoraires={props.montantConventionHonoraires}
          setMontantConventionHonoraires={props.setMontantConventionHonoraires}
          nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
          setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
          adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
          setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
        />
      </div>
    </div>
  );
}

export default Simulateur_82;
